import CardWrapper from '../wrapper/card';
import { CreateProductParams } from '../../params/redux/product';
import { createProductThunk } from '../../redux/thunks/products';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import LabelWrapper from '../wrapper/label';
import { productSchema } from '../../schema/product_schema';
import { settingCreatingProduct } from '../../redux/slices/product';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { currencyOptions, intervalOptions } from '../../helper';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

const CreateProduct = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { loaders } = useSelector((state: RootState) => state.product);
    const initialValues: CreateProductParams = {
        product_name: '',
        product_description: '',
        amount: 0,
        currency: 'usd',
        billing_type: 'one_time',
        interval: 'month',
        interval_count: 1,
        price_description: ''
    };

    const handleSubmit = async (values: CreateProductParams) => {
        try {
            await dispatch(createProductThunk(values)).unwrap();
            dispatch(settingCreatingProduct(false));
        } catch (e) {
            // Catch errors
        }
    };

    return <Box>
        <CardWrapper>
            <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
                            <Button onClick={() => dispatch(settingCreatingProduct(false))} style={{ marginBottom: '10px' }}>
                                &larr; Back
                            </Button><Typography variant="h5" align="center" color="textSecondary" mb={2}>
                Create a Product
            </Typography>
                            <Box></Box>
                        </Box>
            <Formik initialValues={initialValues} validationSchema={productSchema} onSubmit={handleSubmit}>
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                    <Form>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Box>
                                {/* Input field for deal title */}
                                <CustomInput
                                    fullWidth
                                    label="Product Name"
                                    name="prod_name"
                                    placeholder="Type here"
                                    value={values.product_name}
                                    onChange={handleChange('product_name')}
                                    onBlur={handleBlur('product_name')}
                                    error={touched.product_name && Boolean(errors.product_name)}
                                    disabled={loaders.isCreating}
                                />
                            </Box>
                            {/* Input field for email */}
                            <Box>
                                <CustomInput
                                    fullWidth
                                    type="textarea"
                                    rows={4}
                                    label="Product Description"
                                    name="prod_description"
                                    placeholder="Type here"
                                    value={values.product_description}
                                    onChange={handleChange('product_description')}
                                    onBlur={handleBlur('product_description')}
                                    error={touched.product_description && Boolean(errors.product_description)}
                                    disabled={loaders.isCreating}
                                /></Box>
                            <LabelWrapper label="Price Information" marginBottom="0" />
                            {/* Input field for company */}
                            <Box display="flex" gap={1}>
                                <Box width="100%">
                                    <CustomInput
                                        fullWidth
                                        type="number"
                                        label="Price"
                                        name="prod_price"
                                        value={values.amount}
                                        onChange={handleChange('amount')}
                                        onBlur={handleBlur('amount')}
                                        error={touched.amount && Boolean(errors.amount)}
                                        disabled={loaders.isCreating}
                                    />
                                </Box>
                                {/* Input field for phone */}
                                <Box width="100%">
                                    <LabelWrapper label="Currency" />
                                    <CustomDropdown
                                        options={currencyOptions}
                                        value={values.currency}
                                        onChange={(e) => setFieldValue('currency', e.target.value)}
                                        error={touched.currency && Boolean(errors.currency)}
                                        disabled={loaders.isCreating}
                                    />
                                </Box>
                                {/* Dropdown field for pipeline */}
                                <Box width="100%">
                                    <LabelWrapper label="Frequency" />
                                    <CustomDropdown
                                        options={[{ label: 'One time', value: 'one_time' }, { label: 'Recurring', value: 'recurring' }]}
                                        value={values.billing_type}
                                        onChange={(e) => setFieldValue('billing_type', e.target.value)}
                                        error={touched.billing_type && Boolean(errors.billing_type)}
                                        disabled={loaders.isCreating}
                                    />
                                </Box>
                                {values.billing_type === 'recurring' && <Box width="100%">
                                    <LabelWrapper label="Interval" />
                                    <CustomDropdown
                                        options={intervalOptions}
                                        value={values.interval}
                                        onChange={(e) => {
                                            if (e.target.value === 'three') {
                                                setFieldValue('interval', 'month');
                                                setFieldValue('interval_count', 3);
                                            } else if (e.target.value === 'six') {
                                                setFieldValue('interval', 'month');
                                                setFieldValue('interval_count', 6);
                                            } else {
                                                setFieldValue('interval', e.target.value);
                                            }
                                        }}
                                        error={touched.interval && Boolean(errors.interval)}
                                        disabled={loaders.isCreating}
                                    />
                                </Box>}
                            </Box>
                            {/* Dropdown field for stage */}
                            <Box>
                                <CustomInput
                                    fullWidth
                                    label="Price Description"
                                    type="textarea"
                                    rows={4}
                                    placeholder="Type here"
                                    name="prod_price_description"
                                    value={values.price_description}
                                    onChange={handleChange('price_description')}
                                    onBlur={handleBlur('price_description')}
                                    error={touched.price_description && Boolean(errors.price_description)}
                                    disabled={loaders.isCreating}
                                />
                            </Box>
                            {/* Action Buttons */}
                            <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                                <Button variant="outlined" color="primary" onClick={() => dispatch(settingCreatingProduct(false))} disabled={loaders.isCreating}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" color="primary" disabled={loaders.isCreating}>
                                    {loaders.isCreating ? 'Creating...' : 'Create'}
                                </Button>
                            </Box>
                        </Box>
                    </Form>
                )}
            </Formik>
        </CardWrapper>
    </Box>;
};

export default CreateProduct;